import { shuffle } from '~/lib/shuffle';
import {
  LayoutListDefinition,
  LAYOUT_LIST,
  QuizMatchDefinition,
  QUIZ_MATCH,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const Quiz4: Translator = sequence => {
  return translate(sequence, item => {
    if (item.__typename === 'Question') {
      const listItem: LayoutListDefinition = {
        id: `${item.id}.text-list`,
        type: LAYOUT_LIST,
        values: {
          padded: true,
          align: 'center'
        },
        items: []
      };

      if (item.subtitle) {
        listItem.items.push({
          id: `${item.id}_subtitle`,
          type: TEXT,
          values: {
            value: item.subtitle,
            variant: 'sub_heading',
            icon: item?.icon
          },
          items: []
        });
      }

      if (item.title) {
        listItem.items.push({
          id: `${item.id}_title`,
          type: TEXT,
          values: {
            value: item.title,
            variant: 'heading2'
          },
          items: []
        });
      }

      if (item.body) {
        listItem.items.push({
          id: `${item.id}_body`,
          type: TEXT,
          values: {
            value: item.body
          },
          items: []
        });
      }

      listItem.items.push({
        id: `${item.id}.quiz-match`,
        type: QUIZ_MATCH,
        values: {
          leftItems: shuffle(
            item.items?.map(({ id, value }) => ({
              label: value,
              pairId: id
            })) || []
          ),
          rightItems: shuffle(
            item.items?.map(({ id, feedback }) => ({
              label: feedback,
              pairId: id
            })) || []
          )
        }
      } as QuizMatchDefinition);

      return listItem;
    }
    return null;
  });
};
